import React from "react";
import star_icon from "../assets/cafe/star_icon.png";
import start_dull_icon from "../assets/cafe/star_dull_icon.png";

// Renders as a fragment (no wrapping element) so it drops into flex rows
// like .productdisplay-right-star without extra markup. Pass onChange to
// make it an interactive picker (used by the review form).
const StarRating = ({ rating = 0, onChange }) => {
    const rounded = Math.round(rating);
    return (
        <>
            {[1, 2, 3, 4, 5].map((n) => (
                <img
                    key={n}
                    src={n <= rounded ? star_icon : start_dull_icon}
                    alt=""
                    onClick={onChange ? () => onChange(n) : undefined}
                    style={onChange ? { cursor: "pointer" } : undefined}
                />
            ))}
        </>
    );
};

export default StarRating;
